import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { Tree } from "antd";
import "../../css/companyTree.css";
import {
  TextField,
  Paper,
  Button,
  Typography,
  CircularProgress
} from "@material-ui/core";
import { AddOutlined, Search } from "@material-ui/icons";
import * as localforage from "localforage";
import useStyles from "../../styles/accountCenterStyle.js";
import { useTranslation } from "../../langs/useTranslation";
import { getCompanyTreeAPI } from "../../apis/getCompanyTreeAPI";
import HasPermission from "../commons/HasPermission";
import { useHistory } from "react-router-dom";
import { useBoundingRect } from "../../helpers/useBoundingRect";
import { useUpdateEffect } from "ahooks";

const CompanyTree = () => {
  let history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation("accountCenter");
  const [treeData, setTreeData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState(true);
  const [filteredTreeData, setFilteredTreeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const timer = useRef(null);

  const [bbox, treeOuterRef] = useBoundingRect();

  const expKeys = new Set();
  const filterTreeBySearch = (data = []) => {
    if (!searchValue) {
      if (treeData.length > 0) {
        expKeys.add(treeData[0].key);
      }
      return treeData;
    }
    return data
      .map(item => {
        const titleLowerCase = item.title.toLowerCase();
        const itemTitle = item.title;
        const num = item.num;
        const index = titleLowerCase.indexOf(searchValue.toLowerCase());
        const beforeStr = itemTitle.substr(0, index);
        const afterStr = itemTitle.substr(index + searchValue.length);
        const valueStr = itemTitle.substr(index, searchValue.length);

        let title = "";
        let childrenResult = filterTreeBySearch(item.children);

        if (index > -1) {
          if (searchValue !== "" && item.parent_id) {
            expKeys.add(item.parent_id);
          }
          title = (
            <span className="tree-outer">
              {beforeStr}
              <span className="site-tree-search-value">{valueStr}</span>
              {afterStr}
            </span>
          );
          return {
            title,
            key: item.key,
            children: childrenResult,
            name: itemTitle,
            checkable: item.checkable,
            isLeaf: item.isLeaf
          };
        } else if (childrenResult.length > 0) {
          if (searchValue !== "" && item.parent_id) {
            expKeys.add(item.parent_id);
          }
          title = <span className="tree-outer">{item.title}</span>;
          return {
            title,
            key: item.key,
            children: childrenResult,
            name: itemTitle,
            checkable: item.checkable,
            isLeaf: item.isLeaf
          };
        } else {
          return null;
        }
      })
      .filter(item => item ?? false);
  };

  const getTreeData = async () => {
    try {
      setLoading(true);
      await getCompanyTreeAPI(true);
      const companyTree = await localforage.getItem("companyTree");
      setTreeData(companyTree);
      setExpandedKeys(companyTree.map(d => d.key));
    } finally {
      setLoading(false);
    }
  };

  const onExpand = expandedKeys => {
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const onChange = e => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const onSelect = selectedKeys => {
    history.push(`/company-profile/${selectedKeys}`);
  };

  const clearTimer = () => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  };

  useEffect(() => {
    getTreeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useUpdateEffect(() => {
    timer.current = setTimeout(() => {
      setFilteredTreeData(filterTreeBySearch(treeData));
      setExpandedKeys(Array.from(expKeys));
    }, 200);

    return clearTimer;
  }, [searchValue]);

  const finalTreeData = !!searchValue ? filteredTreeData : treeData;

  return (
    <Paper elevation={0} className={classes.companyTreeContent}>
      <div className={classes.companyTreeHeader}>
        <Typography variant="h5" className={classes.companyTreeTitle}>
          {t("accountCenter.companyTreeTitle")}
        </Typography>
        <div className={classes.companyTreeAction}>
          <div className={classes.searchInput}>
            <TextField
              size="small"
              // className={classes.customInput}
              label={t("accountCenter.searchBarTitle")}
              variant="outlined"
              onChange={onChange}
            />
            {/* <Search className={classes.searchIcon} color="action" /> */}
          </div>
          <HasPermission permission="create_company">
            <NavLink to="/company-profile/new">
              <Button
                variant="contained"
                color="primary"
                className={classes.createCompanyBtn}
                startIcon={<AddOutlined />}
              >
                {t("accountCenter.createCompanyBtnText")}
              </Button>
            </NavLink>
          </HasPermission>
        </div>
      </div>
      {loading ? (
        <CircularProgress size={30} className={classes.loading} />
      ) : finalTreeData.length > 0 ? (
        <Paper elevation={0}>
          <div className={classes.treeOuter} id="treeOuter" ref={treeOuterRef}>
            <Tree
              defaultExpandAll={true}
              showIcon={false}
              onExpand={onExpand}
              defaultSelectedKeys={[]}
              treeData={finalTreeData}
              expandedKeys={expandedKeys}
              autoExpandParent={autoExpandParent}
              onSelect={onSelect}
              showLine={{ showLeafIcon: false }}
              height={bbox.height ? bbox.height : 390}
            />
          </div>
        </Paper>
      ) : (
        <div style={{ textAlign: "center" }}>
          <p>No matched result.</p>
        </div>
      )}
    </Paper>
  );
};
export default CompanyTree;
